/**
 * AquaMap USACE survey depth colors and transitions (Ted Arisaka colors,
 * Bob423 / USACE MLLW legend breakpoints, Aug 2026).
 */
export const DEPTH_BANDS_FT = [
  { minFt: 0, maxFt: 3.5, color: "#D20D17" },
  { minFt: 3.5, maxFt: 5.5, color: "#FC561F" },
  { minFt: 5.5, maxFt: 6.5, color: "#FCAA29" },
  { minFt: 6.5, maxFt: 7.5, color: "#FFFB38" },
  { minFt: 7.5, maxFt: 9.5, color: "#ADFD32" },
  { minFt: 9.5, maxFt: 11.5, color: "#5EFD2F" },
  { minFt: 11.5, maxFt: 13.5, color: "#74DEFC" },
  { minFt: 13.5, maxFt: 15.5, color: "#23C9FB" },
  { minFt: 15.5, maxFt: Infinity, color: "#3E99FA" },
];

export function bandForDepthFt(depthFt) {
  const depth = Number(depthFt);
  if (!Number.isFinite(depth) || depth < 0) {
    return DEPTH_BANDS_FT[0];
  }
  return (
    DEPTH_BANDS_FT.find((band) => depth < band.maxFt) ||
    DEPTH_BANDS_FT[DEPTH_BANDS_FT.length - 1]
  );
}

export function bandLabel(band, metric) {
  const format = (feet) => (metric ? (feet * 0.3048).toFixed(1) : String(feet));
  const unit = metric ? "m" : "ft";
  if (band.minFt === 0) {
    return `< ${format(band.maxFt)} ${unit}`;
  }
  if (band.maxFt === Infinity) {
    return `> ${format(band.minFt)} ${unit}`;
  }
  return `${format(band.minFt)}–${format(band.maxFt)} ${unit}`;
}
